import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DroneService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    private readonly httpClient: HttpClient,
  ) { }

  private extractData(res: Response) {
    return res || {}
  }

  findAll(): Observable<any> {
    return this.httpClient.get(this.API_SERVER + 'drones').pipe(
      map(this.extractData)
    )
  }

  create(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'drones', data).pipe(
      map(this.extractData)
    )
  }

  findOne(id): Observable<any> {
    return this.httpClient.get(this.API_SERVER + `drones/${id}`).pipe(
      map(this.extractData)
    )
  }

  update(id, data): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `drones/${id}`, data).pipe(
      map(this.extractData)
    )
  }
}
